import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderDeletionImpact } from '@core/models/job-file/order-deletion-impact.model';

export interface SimpleOrderDeletionDialogData {
  impact: OrderDeletionImpact;
}

export interface SimpleOrderDeletionDialogResult {
  action: 'delete-all' | 'delete-order-only' | 'cancel';
  activitiesToDelete: string[];
}

@Component({
  selector: 'hmt-simple-order-deletion-dialog',
  templateUrl: './simple-order-deletion-dialog.component.html',
  styleUrls: ['./simple-order-deletion-dialog.component.scss'],
  standalone: false
})
export class SimpleOrderDeletionDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<SimpleOrderDeletionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SimpleOrderDeletionDialogData
  ) {}

  get hasActivitiesToDelete(): boolean {
    return this.data.impact.activitiesToDelete && this.data.impact.activitiesToDelete.length > 0;
  }

  get activityCount(): number {
    return this.data.impact.activitiesToDelete?.length || 0;
  }

  get activityText(): string {
    return this.activityCount === 1 ? 'activity' : 'activities';
  }

  onYesClick(): void {
    const result: SimpleOrderDeletionDialogResult = {
      action: 'delete-all',
      activitiesToDelete: this.data.impact.activitiesToDelete?.map(activity => activity.id) || []
    };
    this.dialogRef.close(result);
  }

  onNoClick(): void {
    const result: SimpleOrderDeletionDialogResult = {
      action: 'delete-order-only',
      activitiesToDelete: []
    };
    this.dialogRef.close(result);
  }

  onCancelClick(): void {
    const result: SimpleOrderDeletionDialogResult = {
      action: 'cancel',
      activitiesToDelete: []
    };
    this.dialogRef.close(result);
  }
}

